module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABGklEQVQ4ja3UvytFcRjH8de93SgpP8rMYKAkMkhZDEYGPxb+Ail/AP+EyWKw2ESJibBL5ObOSmRRMigm+t7Oret27u0c57ynp57nvPt8v9/TU1D5gVFMoc3/ecRZCYO4zyCq57CIkZxkgYUgLOUoLBSbNB6wide0xrh0FUzjAye4QXtSYVzCo0hWS3qcJmGccKCu7sNkVuEcOqN6Hf1Zhd3YiOpdvGcVBrYwhBcs4jursCN6nC5cRdfwWdf/SisMDOM0kp5Hj3OB7eiOZ/HW+FFYDks4aCG+wzyeY3ozuEyasMY4ylitBvhLb+NwEmGgB/u4xRomsIK9xsG0i2EMO60GQsLqhs2LIHzK0VcOwrBNwjGa/lsJucbyL8ULLq4h9HIaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/sipicon/index_phone_click.png
// module id = at1a
// module chunks = 4